import { TextField } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { useAppDispatch, useAppSelector } from '../../store/hooks';
import { setUploadReason } from '../../store/upload/uploadSlice';
import OnBehalfOfField from '../OnBehalfOfField';
import { Stack } from '@mui/system';

const UploadReasonField: React.FC<{ forceDisabled?: boolean }> = ({ forceDisabled }) => {
	const dispatch = useAppDispatch();

	const uploadReason = useAppSelector((state) => state.upload.uploadReason);
	const [reason, setReason] = useState<string>('');

	useEffect(() => {
		dispatch(
			setUploadReason({
				reason: reason,
				onBehalfOf: uploadReason.onBehalfOf,
				onBehalfOfName: uploadReason.onBehalfOfName,
				onBehalfOfEmail: uploadReason.onBehalfOfEmail,
			})
		);
	}, [reason]);

	return (
		<Stack gap={2}>
			<TextField
				variant="outlined"
				fullWidth
				value={reason}
				onChange={(e) => setReason(e.target.value)}
				helperText={
					<>
						The Investigation URN or Case Reference Number for this file<br></br>Must be 5 characters or more, and must be correctly
						specified before file upload is allowed
					</>
				}
				disabled={forceDisabled}
				required
				data-testid={`upload-reason-textfield`}
				label="Reason for Processing"
			/>
			<OnBehalfOfField />
		</Stack>
	);
};

export default UploadReasonField;
